const uk = {
    nav: {
      home: "Головна",
      browse: "Переглянути весілля",
      dashboard: "Панель керування",
      messages: "Повідомлення",
      profile: "Профіль",
      login: "Увійти",
      register: "Реєстрація",
      logout: "Вийти",
      admin: "Адмін",
      faq: "FAQ",
      about: "Про нас",
      contact: "Контакти",
      pricing: "Ціни",
      howItWorks: "Як це працює",
    },
    auth: {
      login: {
        title: "З поверненням",
        email: "Email",
        password: "Пароль",
        button: "Увійти",
        noAccount: "Немає акаунту?",
        register: "Зареєструйтесь",
      },
      register: {
        title: "Створити акаунт",
        name: "Повне ім'я",
        email: "Email",
        password: "Пароль",
        role: "Я хочу...",
        roleHost: "Організувати весілля",
        roleGuest: "Відвідувати весілля",
        terms: "Я приймаю умови та політику конфіденційності",
        button: "Зареєструватися",
        hasAccount: "Вже зареєстровані?",
        login: "Увійдіть",
      },
    },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

    common: {
      loading: "Завантаження...",
      error: "Сталася помилка",
      success: "Успішно",
      save: "Зберегти",
      cancel: "Скасувати",
      delete: "Видалити",
      edit: "Редагувати",
      back: "Назад",
      next: "Далі",
      language: "Мова",
      currency: "Валюта",
      search: "Пошук",
      filter: "Фільтр",
      all: "Всі",
      none: "Немає",
      yes: "Так",
      no: "Ні",
    },
    footer: {
      about: "Про нас",
      privacy: "Конфіденційність",
      terms: "Умови",
      contact: "Контакти",
      copyright: "© 2024 WEDVAYA. Усі права захищені.",
    },
  };

export default uk;
